import React from "react";
import Chart from "react-apexcharts";

// Vault tiers are always shown in play order, not data order.
const TIER_ORDER = ["iceBreaker", "deeperDive", "wildCard", "connectionGoals"];

const TIER_LABELS = {
  iceBreaker: "Ice Breaker",
  deeperDive: "Deeper Dive",
  wildCard: "Wild Card",
  connectionGoals: "Connection Goals",
};

const TierSummaryChart = ({ data = [] }) => {
  if (!data.length) {
    return <div className="text-muted text-center">No data available</div>;
  }

  // Group by tier
  const tierMap = {};

  data.forEach((q) => {
    if (!tierMap[q.tier]) {
      tierMap[q.tier] = { views: 0, answered: 0, skipped: 0 };
    }
    tierMap[q.tier].views += q.views;
    tierMap[q.tier].answered += q.answered;
    tierMap[q.tier].skipped += q.skipped;
  });

  const tiers = TIER_ORDER.filter((t) => tierMap[t]).concat(
    Object.keys(tierMap).filter((t) => !TIER_ORDER.includes(t))
  );

  const categories = tiers.map((t) => TIER_LABELS[t] || t);

  const completed = tiers.map((tier) => {
    const { views, answered } = tierMap[tier];
    return views ? +(answered / views * 100).toFixed(2) : 0;
  });

  const dropped = tiers.map((tier) => {
    const { views, skipped } = tierMap[tier];
    return views ? +(skipped / views * 100).toFixed(2) : 0;
  });

  const series = [
    { name: "Completed %", data: completed },
    { name: "Dropped Off %", data: dropped },
  ];

  const options = {
    chart: { type: "bar", stacked: true },
    xaxis: { categories },
    yaxis: {
      max: 100,
      labels: { formatter: (v) => `${v}%` },
    },
    legend: { position: "bottom" },
    tooltip: {
      y: {
        formatter: (v, { seriesIndex, dataPointIndex }) => {
          const t = tierMap[tiers[dataPointIndex]];
          if (!t) return `${v}%`;
          const count = seriesIndex === 0 ? t.answered : t.skipped;
          const word = seriesIndex === 0 ? "answered" : "skipped";
          return `${v}% (${count} ${word} of ${t.views} views)`;
        },
      },
    },
  };

  return <Chart options={options} series={series} type="bar" height={360} />;
};

export default TierSummaryChart;
